import React, { MutableRefObject, ReactNode } from 'react';
import style from './RoundIcon.scss';
import { AccessibilityElement } from 'js/components/common/AccessibilityElement';
import { useTranslations } from 'js/hooks/i18n';

type RoundIconProps = {
    type?: string;
    onClick?: (event: React.MouseEvent<HTMLElement>) => void;
    children?: ReactNode;
    className?: string;
    containerClassName?: string;
    iconRef?: MutableRefObject<HTMLDivElement | null>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    other?: { [x: string]: any; }
};

export const RoundIcon = ({ type = '', onClick, children = null, className = '', containerClassName = '', iconRef, ...other }: RoundIconProps) => {
    const translate = useTranslations('playtech.mobile.system.responsivegames.game.infoPopup.');

    return (<div className={`${style.roundIconContainer} ${containerClassName}`} ref={iconRef}>
        {onClick
            ? (
                <AccessibilityElement
                    tagName="button"
                    inline={true}
                    onClick={onClick}
                    className={`${style.common} ${className}`}
                    aria-label={translate(`aria-label.${type}`)}
                    {...other}>
                    {children || <span className={`${style.icon} ${style[type]}`}/>}
                </AccessibilityElement>
            ) : (
                <span className={style.common} {...other} >
                    <span className={`${style.icon} ${style[type]}`}/>
                </span>)
        }
        <span className={style.iconName}>{translate(`icon.${type}`)}</span>
    </div>);
};
